import { render, staticRenderFns } from "./AiJobDescriptionModal.vue?vue&type=template&id=35fc83ec&scoped=true&"
import script from "./AiJobDescriptionModal.vue?vue&type=script&lang=ts&"
export * from "./AiJobDescriptionModal.vue?vue&type=script&lang=ts&"
import style0 from "./AiJobDescriptionModal.vue?vue&type=style&index=0&id=35fc83ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc83ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VRow})
